module.exports = __webpack_public_path__ + "static/media/Giorgio_round.79832257.jpg";